import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

import { environment } from "../../environments/environment";

@Injectable({ providedIn: "root" })
export class AdmissionsService {
    constructor(private http: HttpClient) { }

    getApplications(studentRegistrationId: number) {
        return this.http.get<any>(`${environment.apiUrl}/PortalAdmissions/GetApplications?studentRegistrationId=${studentRegistrationId}`);
    }

    insertOrUpdateAdmissionsApplicationPersonalDetails(saveModel: any) {
        return this.http.post(`${environment.apiUrl}/PortalAdmissions/InsertOrUpdateApplicationPersonalDetails`, saveModel);
    }

    getAdmissionsApplication(applicationId: number) {
        return this.http.get<any>(`${environment.apiUrl}/PortalAdmissions/GetApplication?applicationId=${applicationId}`);
    }

    insertOrUpdateAdmissionsApplicationEducationDetails(saveModel: any) {
        return this.http.post(`${environment.apiUrl}/PortalAdmissions/InsertOrUpdateApplicationEducationDetails`, saveModel);
    }

    insertOrUpdateAdmissionsApplicationFamilyDetails(saveModel: any) {
        return this.http.post(`${environment.apiUrl}/PortalAdmissions/InsertOrUpdateApplicationFamilyDetails`, saveModel);
    }

    submitApplication(saveModel: any) {
        return this.http.post(`${environment.apiUrl}/PortalAdmissions/SubmitApplication`, saveModel);
    }

    getAdmissionsApplicationPdf(admissionsApplicationId: number) {
        const httpOptions = {
            'responseType': (("arraybuffer") as any) as "json"
        };

        return this.http.get<any>(`${environment.apiUrl}/PortalAdmissions/AdmissionsApplicationPdf?admissionsApplicationId=${admissionsApplicationId}`, httpOptions);
    }

    getAdmissionsApplicationDocuments(admissionsApplicationId: number, funnelId: number) {
        return this.http.get<any>(`${environment.apiUrl}/PortalAdmissions/AdmissionsApplicationDocuments?admissionsApplicationId=${admissionsApplicationId}&funnelId=${funnelId}`);
    }

    insertOrUpdateAdmissionsApplicationDocumentDetails(saveModel: any) {
        return this.http.post(`${environment.apiUrl}/PortalAdmissions/UploadApplicationDocument`, saveModel);
    }

    updateHousingRequirement(saveModel: any) {
        return this.http.post(`${environment.apiUrl}/PortalAdmissions/UpdateHousingRequirement`, saveModel);
    }
}